import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { PolarArea } from 'react-chartjs-2';

const SlideComponent = ({ actual, first, second, onSaveAnswers }) => {
    const { t } = useTranslation();

    const savedAnswer = JSON.parse(localStorage.getItem('currentAnswer') || '[]');
    const {
        selectedButtonGroup0,  selectedButtonGroup1,  selectedButtonGroup2,
        selectedButtonGroup3,  selectedButtonGroup4,  selectedButtonGroup5,
        selectedButtonGroup6,  selectedButtonGroup7,  selectedButtonGroup8,
    } = savedAnswer;

    const sweetness = t('taste.sweetness', { returnObjects: true });
    const acidity   = t('taste.acidity',   { returnObjects: true });
    const tannin    = t('taste.tannin',    { returnObjects: true });
    const body      = t('taste.body',      { returnObjects: true });
    const finish    = t('taste.finish',    { returnObjects: true });

    const taste_a = typeof selectedButtonGroup6?.a === 'number' ? sweetness[selectedButtonGroup6.a] : '';
    const taste_b = typeof selectedButtonGroup6?.b === 'number' ? acidity[selectedButtonGroup6.b] : '';
    const taste_c = typeof selectedButtonGroup6?.c === 'number' ? tannin[selectedButtonGroup6.c] : '';
    const taste_d = typeof selectedButtonGroup6?.d === 'number' ? body[selectedButtonGroup6.d] : '';
    const taste_e = typeof selectedButtonGroup6?.e === 'number' ? finish[selectedButtonGroup6.e] : '';

    const data = {
        labels: ['', '', '', '', ''],
        datasets: [
            { label: t('taste.acidity_label'),   data: [selectedButtonGroup6?.b + 1 || 0, 0, 0, 0, 0], backgroundColor: 'rgba(210,164,62,0.7)',  borderColor: 'transparent', borderWidth: 3 },
            { label: t('taste.tannin_label'),    data: [0, selectedButtonGroup6?.c + 1 || 0, 0, 0, 0], backgroundColor: 'rgba(106,16,16,0.7)',   borderColor: 'transparent', borderWidth: 1 },
            { label: t('taste.body_label'),      data: [0, 0, selectedButtonGroup6?.d + 1 || 0, 0, 0], backgroundColor: 'rgba(84,34,61,0.7)',    borderColor: 'transparent', borderWidth: 3 },
            { label: t('taste.finish_label'),    data: [0, 0, 0, selectedButtonGroup6?.e + 1 || 0, 0], backgroundColor: 'rgba(29,154,120,0.7)',  borderColor: 'transparent', borderWidth: 3 },
            { label: t('taste.sweetness_label'), data: [0, 0, 0, 0, selectedButtonGroup6?.a + 1 || 0], backgroundColor: 'rgba(167,149,129,0.7)', borderColor: 'transparent', borderWidth: 3 },
        ],
    };
    const options = {
        scales: { r: { angleLines: { display: true, color: 'rgba(0,0,0,0.1)' }, grid: { color: 'rgba(0,0,0,0.1)' }, suggestedMin: 0, suggestedMax: 3, ticks: { display: false }, pointLabels: { font: { size: 0 } } } },
        plugins: { legend: false, tooltip: { enabled: true, callbacks: { label: (ctx) => ctx.dataset.label } } },
    };

    return (
        <div className="an-slide">
            <h2 className="an-slide-title">{t('note.title')}</h2>

            <div className="an-note-grid">
                <div className="an-note-text">
                    <div className="an-section-title">{t('note.title')}</div>
                    <p className="an-tasting-text">
                        {t('note.tasting_text', {
                            color1: selectedButtonGroup1,
                            color0: selectedButtonGroup0,
                            intensity: selectedButtonGroup2,
                            primary:   selectedButtonGroup3?.join(', '),
                            secondary: selectedButtonGroup4?.join(', '),
                            tertiary:  selectedButtonGroup5?.join(', '),
                            taste_a, taste_b, taste_c, taste_d, taste_e,
                        })}
                    </p>
                    <div className="an-chart"><PolarArea data={data} options={options} /></div>
                </div>

                <div className="an-select-col">
                    <div className="an-select-item">
                        <h4>{t('note.variety')}</h4>
                        <select readOnly><option>{selectedButtonGroup7?.selector1}</option></select>
                    </div>
                    <div className="an-select-item">
                        <h4>{t('note.country')}</h4>
                        <select readOnly><option>{selectedButtonGroup7?.selector2}</option></select>
                    </div>
                    <div className="an-select-item">
                        <h4>{t('note.region')}</h4>
                        <select readOnly><option>{selectedButtonGroup7?.selector3}</option></select>
                    </div>
                    <div className="an-select-item">
                        <h4>{t('note.price')}</h4>
                        <input type="range" min="0" max="100" value={selectedButtonGroup8 || 0} readOnly onChange={() => {}} />
                        <p>{t('note.price_label')} {selectedButtonGroup8}&euro;</p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SlideComponent;
